import Main from './components/Main';
import NavMenu from './components/NavMenu';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

const App = () => {
    const helmetContext = {};
    return (
        <HelmetProvider context={helmetContext}>
            <BrowserRouter>
                <NavMenu />
                <Main />
            </BrowserRouter>
        </HelmetProvider>
    );
};


export default App;